/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Privacy_CrumbInputs */

const en_auth_privacy_crumb = /** @type {(inputs: Auth_Privacy_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

const pl_auth_privacy_crumb = /** @type {(inputs: Auth_Privacy_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatność`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Auth_Privacy_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_privacy_crumb = /** @type {((inputs?: Auth_Privacy_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Privacy_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_privacy_crumb(inputs)
	return en_auth_privacy_crumb(inputs)
});